import PropTypes from "prop-types";

export default {
	title: PropTypes.string,
	description: PropTypes.string,
	tagline: PropTypes.string,
	isVisible: PropTypes.bool,
};
